<template>
  <div>
    <TextLinkList href="/" text="テキストリンクリスト（下線無し）" />
    <TextLinkList href="/" text="テキストリンクリスト" :border="true" />
  </div>
</template>
<script>
import TextLinkList from '../../components/molecules/text_link_lists/TextLinkList.vue'
export default {
  components: { TextLinkList }
}
</script>
